"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.chaletFactory = chaletFactory;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _language = require("../utils/language.utils");

var _cancellationPolicy = require("./cancellation-policy.factory");

const serializeDailyPrice = ({
  dailyPriceInfo,
  formatPrice,
  displayCurrency
}) => {
  return { ...dailyPriceInfo,
    displayPrice: formatPrice(dailyPriceInfo == null ? void 0 : dailyPriceInfo.price),
    displayDiscountPrice: formatPrice(dailyPriceInfo == null ? void 0 : dailyPriceInfo.discountPrice),
    displayCurrency
  };
};
/**
 * chaletFactory
 */


function chaletFactory({
  product,
  language,
  cartTotalPrice,
  formatPrice
}) {
  var _product$options, _product$options$prop, _location$city, _location$city2, _product$additionalDa, _product$additionalDa2, _product$additionalDa3;

  const displayCurrency = product == null ? void 0 : product.displayPrice.currency;
  const propertySearchId = product == null ? void 0 : (_product$options = product.options) == null ? void 0 : (_product$options$prop = _product$options.property) == null ? void 0 : _product$options$prop.propertySearchIDResponse;
  const propertyDetails = propertySearchId == null ? void 0 : propertySearchId.propertyDetailsExtension;
  const location = propertyDetails == null ? void 0 : propertyDetails.location;
  const property = 'options.property.propertySearchIDResponse.propertyDetailsExtension';
  const checkIn = (0, _get2.default)(product, `${property}.checkinBeginTime`);
  const checkOut = (0, _get2.default)(product, `${property}.checkoutEndTime`);
  const nameAr = (propertyDetails == null ? void 0 : propertyDetails.nameAr) || '';
  const nameEn = (propertyDetails == null ? void 0 : propertyDetails.nameEn) || '';
  const originalNameEn = (0, _get2.default)(product, `${property}.originalNameEn`);
  const originalNameAr = (0, _get2.default)(product, `${property}.originalNameAr`);
  const originalProperty = (0, _get2.default)(product, `${property}.property`);
  const addressAr = (location == null ? void 0 : location.addressAr) || '';
  const addressEn = (location == null ? void 0 : location.addressEn) || '';
  const cityNameAr = (location == null ? void 0 : (_location$city = location.city) == null ? void 0 : _location$city.nameAr) || '';
  const cityNameEn = (location == null ? void 0 : (_location$city2 = location.city) == null ? void 0 : _location$city2.nameEn) || '';
  const areaEn = (0, _get2.default)(product, `${property}.location.area.nameEn`);
  const areaAr = (0, _get2.default)(product, `${property}.location.area.nameAr`);
  const rules = propertyDetails == null ? void 0 : propertyDetails.rules;
  const userTypeEn = (0, _get2.default)(product, `${property}.contacts[0].userTypeEn`);
  const userTypeAr = (0, _get2.default)(product, `${property}.contacts[0].userTypeAr`);
  const expiredAt = (product == null ? void 0 : (_product$additionalDa = product.additionalData) == null ? void 0 : _product$additionalDa.expiredAt) || '';
  const unitCancellationPolicies = product == null ? void 0 : (_product$additionalDa2 = product.additionalData) == null ? void 0 : (_product$additionalDa3 = _product$additionalDa2.cancellationPolicies) == null ? void 0 : _product$additionalDa3.guestCancellationPolicies;
  return {
    propertyId: propertyDetails == null ? void 0 : propertyDetails.propertyId,
    unitCancellationPolicy: unitCancellationPolicies == null ? void 0 : unitCancellationPolicies.map(currentUnitPolicy => (0, _cancellationPolicy.cancellationPolicyFactory)({
      currentUnitPolicy,
      formatPrice,
      displayCurrency
    })),
    propertyName: (0, _language.localize)({
      source: {
        nameAr,
        nameEn
      },
      key: 'name',
      language
    }),
    propertyOriginalName: (0, _language.localize)({
      source: {
        originalNameEn,
        originalNameAr
      },
      key: 'originalName',
      language
    }),
    propertyExtensionName: (0, _language.localize)({
      source: originalProperty,
      key: 'name',
      language
    }),
    address: (0, _language.localize)({
      source: {
        addressAr,
        addressEn
      },
      key: 'address',
      language
    }),
    cityName: (0, _language.localize)({
      source: {
        cityNameAr,
        cityNameEn
      },
      key: 'cityName',
      language
    }),
    district: (0, _language.localize)({
      source: {
        areaAr,
        areaEn
      },
      key: 'area',
      language
    }),
    // location object is used by payment sdk
    location: {
      lat: (0, _get2.default)(product, `${property}.location.latitude`),
      long: (0, _get2.default)(product, `${property}.location.longitude`),
      areaEn: (0, _get2.default)(product, `${property}.location.area.nameEn`),
      areaAr: (0, _get2.default)(product, `${property}.location.area.nameAr`),
      cityEn: (0, _get2.default)(product, `${property}.location.city.nameEn`),
      cityAr: (0, _get2.default)(product, `${property}.location.city.nameAr`),
      cityId: (0, _get2.default)(product, `${property}.location.city.id`)
    },
    contact: {
      firstName: (0, _get2.default)(product, `${property}.contacts[0].firstName`),
      phone: (0, _get2.default)(product, `${property}.contacts[0].phone`),
      hasWhatsapp: (0, _get2.default)(product, `${property}.contacts[0].hasWhatsapp`),
      address: (0, _language.localize)({
        source: {
          addressAr,
          addressEn
        },
        key: 'address',
        language
      }),
      userType: (0, _language.localize)({
        source: {
          userTypeEn,
          userTypeAr
        },
        key: 'userType',
        language
      })
    },
    timeAndDate: {
      checkInDate: (0, _get2.default)(product, 'options.property.propertySearchIDResponse.checkIn'),
      checkOutDate: (0, _get2.default)(product, 'options.property.propertySearchIDResponse.checkOut'),
      checkInBeginTime: (0, _get2.default)(product, `${property}.checkinBeginTime`),
      checkOutEndTime: (0, _get2.default)(product, `${property}.checkoutEndTime`)
    },
    totals: {
      cartTotalPrice: (0, _get2.default)(cartTotalPrice, 'total'),
      displayCartTotalPrice: formatPrice((0, _get2.default)(cartTotalPrice, 'total', 0)),
      totalPrice: (0, _get2.default)(product, `${property}.priceDetail.totalPrice`),
      displayTotalPrice: formatPrice((0, _get2.default)(product, `${property}.priceDetail.totalPrice`, 0)),
      currency: (0, _get2.default)(product, `${property}.priceDetail.currency`),
      insuranceAmount: formatPrice((0, _get2.default)(product, `${property}.insuranceAmount`)),
      originalPrice: (0, _get2.default)(cartTotalPrice, 'subtotal'),
      displayOriginalPrice: formatPrice((0, _get2.default)(cartTotalPrice, 'subtotal', 0))
    },
    rules: { ...rules,
      checkIn,
      checkOut,
      displayInsuranceAmount: formatPrice((0, _get2.default)(rules, `insurance`, 0)),
      insuranceAmount: (0, _get2.default)(rules, `insurance`, 0)
    },
    thumbnailImageUrl: (0, _get2.default)(product, `${property}.thumbnailImageUrl`),
    numberOfNights: (0, _get2.default)(product, 'additionalData.pricingRules.numberOfNights'),
    guests: (0, _get2.default)(product, 'traveller'),
    displayCurrency,
    baseCurrency: (0, _get2.default)(product, `${property}.priceDetail.currency`),
    expiredAt
  };
}